import './App.css';
import {
  Button,
  Card,
  ColorPicker,
  Divider,
  Flex,
  Form,
  Input,
  message,
  Modal,
  QRCode,
  Segmented,
  Skeleton,
  Space,
  Typography,
  Upload,
} from 'antd';
import useSWR, { useSWRConfig } from 'swr';
import cookie from 'react-cookies';

import { useNavigate } from 'react-router-dom';
import {
  InboxOutlined,
  LeftCircleOutlined,
  PlusOutlined,
} from '@ant-design/icons';
import { useState } from 'react';
import type { QRCodeProps } from 'antd';
import TextArea from 'antd/es/input/TextArea';
import { UploadProps } from 'antd/lib';
import ImgCrop from 'antd-img-crop';

const { Title } = Typography;

const fetcher = async (url: string) => {
  const token = cookie.load('token');
  const res = await fetch(url, {
    headers: new Headers({
      'Access-Control-Allow-Origin': '*',
      Authorization: `Bearer ${token}`,
    }),
  });
  const json = await res.json();
  if (!json.success) {
    const error = new Error((await json).message);
    throw error;
  }
  return json;
};

function doDownload(url: string, fileName: string) {
  const a = document.createElement('a');
  a.download = fileName;
  a.href = url;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
}

const downloadCanvasQRCode = () => {
  const canvas = document
    .getElementById('myqrcode')
    ?.querySelector<HTMLCanvasElement>('canvas');
  if (canvas) {
    const url = canvas.toDataURL();
    doDownload(url, 'QRCode.png');
  }
};

const VoiceCategoryManage = () => {
  const { mutate } = useSWRConfig();
  const [addVoiceForm] = Form.useForm();
  const [editVoiceForm] = Form.useForm();
  const [addVoiceOpen, setAddVoiceOpen] = useState(false);
  const [deleteVoiceOpen, setDeleteVoiceOpen] = useState(false);
  const [editVoiceOpen, setEditVoiceOpen] = useState(false);
  const [editVoice, setEditVoice] = useState<any>({});
  const [deleteVoiceId, setDeleteVoiceId] = useState(0);
  const [QRCodeOpen, setQRCodeOpen] = useState(false);
  const [voiceUrl, setVoiceUrl] = useState('');
  const [level, setLevel] = useState<QRCodeProps['errorLevel']>('M');
  const [color, setColor] = useState('#000000');
  const [bgColor, setBgColor] = useState('#FFFFFF');
  const [createImage, setCreateImage] = useState("");
  const token = cookie.load('token');

  const onCreateVoice = async (values: any) => {
    setAddVoiceOpen(false);
    const image = createImage !== ""
      ? createImage
      : null;
    const description = values.description ? values.description : null;
    const apiResponse = await (
      await fetch('https://api.lynne.com.cn/voice/createCategory', {
        method: 'POST',
        body: JSON.stringify({
          title: values.title,
          description,
          image
        }),
        headers: new Headers({
          'Access-Control-Allow-Origin': '*',
          Authorization: `Bearer ${token}`,
          'Content-type': 'Application/json',
        }),
      })
    ).json();
    if (apiResponse.success) {
      message.success(apiResponse.message);
      mutate('https://api.lynne.com.cn/voice/listCategory');
    } else {
      message.error(apiResponse.message);
    }
    setCreateImage("");
  };

  const onEditVoice = async (values: any) => {
    setEditVoiceOpen(false);
    const image =  createImage !== ""
        ? createImage
        : null;
    const description = values.description ? values.description : null;
    const apiResponse = await (
      await fetch('https://api.lynne.com.cn/voice/editCategory', {
        method: 'POST',
        body: JSON.stringify({
          id: editVoice.id,
          title: values.title,
          description,
          image
        }),
        headers: new Headers({
          'Access-Control-Allow-Origin': '*',
          Authorization: `Bearer ${token}`,
          'Content-type': 'Application/json',
        }),
      })
    ).json();
    if (apiResponse.success) {
      message.success(apiResponse.message);
      mutate('https://api.lynne.com.cn/voice/listCategory');
    } else {
      message.error(apiResponse.message);
    }
    setCreateImage("");
  };

  const onDeleteVoice = async () => {
    setDeleteVoiceOpen(false);
    const apiResponse = await (
      await fetch('https://api.lynne.com.cn/voice/deleteCategory', {
        method: 'POST',
        body: JSON.stringify({
          id: deleteVoiceId,
        }),
        headers: new Headers({
          'Access-Control-Allow-Origin': '*',
          Authorization: `Bearer ${token}`,
          'Content-type': 'Application/json',
        }),
      })
    ).json();
    if (apiResponse.success) {
      message.success(apiResponse.message);
      mutate('https://api.lynne.com.cn/voice/listCategory');
    } else {
      message.error(apiResponse.message);
    }
  };

  const showQRCode = (url: string) => {
    setVoiceUrl(url);
    setQRCodeOpen(true);
    setLevel('M');
  };

  const props: UploadProps = {
    name: 'file',
    action: 'https://nekoda.cn/upload.php',
    headers: {
      authorization: 'authorization-text',
    },
    maxCount: 1,
    onChange(info) {
      if (info.file.status === 'done') {
        setCreateImage(`https://nekoda.cn/usr/uploads/${info.file.response.name}`);
        message.success('图片上传成功');
      } else if (info.file.status === 'error') {
        message.error(`图片上传失败`);
      }
    },
    onRemove() {
      setCreateImage("");
    }
  };

  const {
    data: voiceData,
    error: voiceError,
    isLoading: voiceIsLoading,
  } = useSWR('https://api.lynne.com.cn/voice/listCategory', fetcher);
  const n = useNavigate();
  if (voiceIsLoading || voiceData === undefined) return <Skeleton active />;
  if (voiceError) {
    cookie.remove('token');
    n('/login');
  }


  // 渲染数据
  return (
    <>
      <Modal
        open={QRCodeOpen}
        title='音声二维码'
        okText='下载'
        cancelText='关闭'
        onCancel={() => setQRCodeOpen(false)}
        destroyOnClose
        maskClosable={true}
        onOk={() => {
          downloadCanvasQRCode();
        }}>
        <Space id='myqrcode' direction='vertical' style={{ width: '100%' }}>
          <QRCode
            value={`https://lynne.com.cn/${voiceUrl}`}
            errorLevel={level}
            size={240}
            color={color}
            bgColor={bgColor}></QRCode>
          <Form
            layout='vertical'
            name='placeholder'
            clearOnDestroy
            onFinish={() => {}}>
            <Form.Item
              name='url'
              label='音声链接'
              initialValue={`https://lynne.com.cn/${voiceUrl}`}>
              <Input readOnly></Input>
            </Form.Item>
            <Form.Item name='seg' label='二维码容错等级（越高则像素块越密集）'>
              <Segmented
                options={['L', 'M', 'Q', 'H']}
                defaultValue={'M'}
                value={level}
                onChange={setLevel}
              />
            </Form.Item>
            <Form.Item name='color' label='二维码颜色'>
              <ColorPicker
                onChange={value => setColor(value.toHexString())}
                value={color}
              />
            </Form.Item>
            <Form.Item name='bgcolor' label='二维码背景颜色'>
              <ColorPicker
                onChange={value => setBgColor(value.toHexString())}
                value={color}
              />
            </Form.Item>
          </Form>
        </Space>
      </Modal>
      <Modal
        open={addVoiceOpen}
        title='添加音声'
        okText='添加'
        cancelText='取消'
        okButtonProps={{ autoFocus: true, htmlType: 'submit' }}
        onCancel={() => setAddVoiceOpen(false)}
        destroyOnClose
        maskClosable={false}
        modalRender={dom => (
          <Form
            layout='vertical'
            form={addVoiceForm}
            name='addSong'
            clearOnDestroy
            onFinish={values => onCreateVoice(values)}>
            {dom}
          </Form>
        )}>
        <Form.Item
          name='title'
          label='标题'
          rules={[
            {
              required: true,
              message: '请输入音声标题',
            },
          ]}>
          <Input autoComplete='off' />
        </Form.Item>
        <Form.Item name='description' label='介绍（可选）'>
          <TextArea />
        </Form.Item>
        <Form.Item label='封面（可选）' name='image' valuePropName='file'>
          <ImgCrop rotationSlider quality={1}>
            <Upload {...props} listType='picture-card' maxCount={1}>
              <button style={{ border: 0, background: 'none' }} type='button'>
                <PlusOutlined />
              </button>
            </Upload>
          </ImgCrop>
        </Form.Item>
      </Modal>
      <Modal
        open={editVoiceOpen}
        title='编辑音声'
        okText='编辑'
        cancelText='取消'
        okButtonProps={{ autoFocus: true, htmlType: 'submit' }}
        onCancel={() => setEditVoiceOpen(false)}
        destroyOnClose
        maskClosable={false}
        modalRender={dom => {
          let initial = { ...editVoice };
          editVoiceForm.setFieldsValue(initial);
          return (
            <Form
              layout='vertical'
              form={editVoiceForm}
              name='editSong'
              clearOnDestroy
              onFinish={values => onEditVoice(values)}>
              {dom}
            </Form>
          );
        }}>
        <Form.Item
          name='title'
          label='标题'
          rules={[
            {
              required: true,
              message: '请输入音声标题',
            },
          ]}>
          <Input autoComplete='off' />
        </Form.Item>
        <Form.Item name='description' label='介绍（可选）'>
          <TextArea />
        </Form.Item>
        <Form.Item label='封面（可选）' name='image' valuePropName='file'>
          <ImgCrop rotationSlider quality={1}>
            <Upload
              {...props}
              listType='picture-card'
              maxCount={1}
              defaultFileList={
                editVoice.image
                  ? [
                      {
                        uid: '2',
                        name: `封面`,
                        status: 'done',
                        url: `${editVoice.image}`,
                      },
                    ]
                  : []
              }>
              <button style={{ border: 0, background: 'none' }} type='button'>
                <PlusOutlined />
              </button>
            </Upload>
          </ImgCrop>
        </Form.Item>
      </Modal>
      <Modal
        open={deleteVoiceOpen}
        title='确认删除喵？'
        okText='删除'
        okType='danger'
        cancelText='取消'
        onCancel={() => setDeleteVoiceOpen(false)}
        onOk={() => onDeleteVoice()}
        destroyOnClose>
        这个音声会被删除喵！
      </Modal>
      <Flex align='center' gap={10}>
        <Button
          type='primary'
          shape='circle'
          icon={<LeftCircleOutlined />}
          onClick={() => n('/dashboard')}
        />
        <Title level={3} style={{ margin: '15px 0', flex: 1 }}>
          音声合集管理
        </Title>
      </Flex>
      <Flex align='center' gap={10}>
        <Button type='primary' onClick={() => {
          setCreateImage("");
          setAddVoiceOpen(true);
        }}>
          添加合集
        </Button>
      </Flex>
      <Divider />
      <Space direction='vertical' size={'middle'} style={{ width: '100%' }}>
        {voiceData.data.map(
          (voice: { id: number; title: string; url: string, image: string }) => {
            return (
              <div key={voice.id}>
                <Card bordered={false} style={{ width: '100%' }}>
                  <Flex align='middle' gap={10} wrap>
                    <Space style={{ flex: 1 }}>{voice.title}</Space>
                    <Button
                      type='primary'
                      onClick={() => showQRCode(voice.url)}>
                      查看二维码
                    </Button>
                    <Button type='primary' onClick={() => n(`/dashboard/voice/${voice.id}`)}>
                      音频列表
                    </Button>
                    <Button
                      type='primary'
                      onClick={() => {
                        setEditVoice(voice);
                        setCreateImage(voice.image);
                        setEditVoiceOpen(true);
                      }}>
                      编辑合集
                    </Button>
                    <Button
                      type='primary'
                      danger
                      onClick={() => {
                        setDeleteVoiceId(voice.id);
                        setDeleteVoiceOpen(true);
                      }}>
                      删除合集
                    </Button>
                  </Flex>
                </Card>
              </div>
            );
          }
        )}
        {voiceData.data.length === 0 && (
          <Card bordered={false} style={{ width: '100%' }}>
            还没有音声喔
          </Card>
        )}
      </Space>
    </>
  );
};

export default VoiceCategoryManage;
